module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "takeOver flexcenter"
  }, [_c('transition', [(!_vm.issued) ? _c('div', {
    staticClass: "issuing flexcenter"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "lbold font22"
  }, [_vm._v("引継ぎコード発行")]), _vm._v(" "), _c('div', {
    staticClass: "mb20 font14 divider-top"
  }, [_c('div', [_vm._v("学習情報の引継ぎには引継ぎコードとパスワードが必要です")]), _vm._v(" "), _c('div', [_vm._v("パスワードを設定し引継ぎコードを発行してください")])]), _vm._v(" "), _c('div', {
    staticClass: "password flexcenter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "パスワード (英数半角4～16文字)",
      "maxlength": "16"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.issueing()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "enter",
    on: {
      "click": function($event) {
        return _vm.issueing()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/svg/ar_r_login.svg",
      "alt": "issueing"
    }
  })])]), _vm._v(" "), (_vm.message && !_vm.issued) ? _c('p', {
    staticClass: "error m0"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()]) : _c('div', {
    staticClass: "issuing flexcenter"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "lbold font22"
  }, [_vm._v("引継ぎコード")]), _vm._v(" "), _c('div', {
    staticClass: "code flexcenter font20 divider-top"
  }, [_vm._v(_vm._s(_vm.takeOverCode))]), _vm._v(" "), _c('div', {
    staticClass: "mt30 font14"
  }, [_vm._v("学習情報の引継ぎには引継ぎコードとパスワードが必要です")])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-454c2552", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-454c2552","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TakeOver.vue
// module id = 866
// module chunks = 1